import { render, staticRenderFns } from "./qr-code.vue?vue&type=template&id=36afaf14&scoped=true&lang=pug&"
import script from "./qr-code.vue?vue&type=script&lang=js&"
export * from "./qr-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36afaf14",
  null
  
)

export default component.exports